<template>
  <v-app>
    <v-main>
      <load :show="true" />
      <router-view></router-view>
    </v-main>
  </v-app>
</template>
<style>
#app {
  font-family: "Roboto", "Avenir", Helvetica, Arial, sans-serif;
}
</style>
<script>
import db from "./data_center/questions";
export default {
  name: "App",

  data: () => ({
    //
  }),
  created() {
    this.$root.$emit("spinner::show");
    if (
      !this.$cookies.get("acessado") &&
      process.env.NODE_ENV === "production"
    ) {
      db.logarEescrever(
        { date: new Date().toLocaleDateString("pt-br") },
        "acessos"
      );
      this.$cookies.set("acessado", "true");
    }
  },
};
</script>
<style></style>
